module.exports = __webpack_public_path__ + "img/Manual Exam Upload - Green - Selected.c49f550b.png";